module.exports = __webpack_public_path__ + "img/FR27733.e468de24.png";